import { IResourceComponentsProps, useExport, useTranslate } from "@refinedev/core";

import {
    BooleanField,
    CreateButton,
    DeleteButton,
    EditButton,
    ExportButton,
    List,
    useTable,
} from "@refinedev/antd";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import { Space, Table } from "antd";
import React, {useContext} from 'react';
import {IParameter} from '../../interfaces';
import {StoreContext} from '../../contexts/StoreContext';

export const ParameterList: React.FC<IResourceComponentsProps> = () => {
    const translate = useTranslate();
    const {value, value2} = useContext(StoreContext);
    const [store, setStore] = value;
    const {tableProps} = useTable<IParameter>({
        resource: "parameters",
        meta: { populate: '*' },

        filters: {
            permanent: [
                {
                    field: "seller][id]",
                    operator: 'eq',
                    value: store.id
                }
            ]
        }
    });

    const {triggerExport, isLoading: exportLoading} = useExport<IParameter>();

    return (
            <List
                title={translate('pages.parameter.title', 'Parametri')}
                headerProps={{
                    extra: [
                        <CreateButton/>,
                        // <ExportButton
                        //     onClick={triggerExport}
                        //     loading={exportLoading}
                        // />
                    ],
                }}
            >
                <Table size="small" {...tableProps} rowKey="id"
                       onRow={(record) => {
                           return {
                               onClick: () => {
                                   // console.log("parameter", record);
                               },
                           };
                       }}
                       sticky={true}

                       pagination={{
                           ...tableProps.pagination,
                           showSizeChanger: true,
                       }}>
                    {/*<Table.Column dataIndex="id" key="id" title="ID"/>*/}
                    <Table.Column
                        dataIndex="progressive"
                        key="progressive"
                        title={translate('pages.parameter.progressive', 'Progressivo')}
                    />
                    <Table.Column
                        dataIndex="doc_type"
                        key="doc_type"
                        title={translate('pages.parameter.doc_type', 'Tipo Documento')}
                        render={(value) => value.description }
                    />
                    <Table.Column<{ id: string }>
                        title={translate('pages.parameter.action', 'Azioni')}
                        dataIndex="actions"
                        key="actions"
                        render={(_, record) => (
                            <Space>
                                <EditButton
                                    hideText
                                    size="small"
                                    recordItemId={record.id}
                                />
                                <DeleteButton
                                    mutationMode={'undoable'}
                                    hideText
                                    size="small"
                                    recordItemId={record.id}
                                />
                            </Space>
                        )}
                    />

                </Table>
            </List>
    );
};
